import React, {useMemo} from 'react';
import {useTranslation} from 'react-i18next';
import TabTableMultipleSelection from '../TabTableMultipleSelection';


const MultipleSelectionBar = ({
  actions = [],
  onCancel,
  selectedRowKeys = {},
}) => {
  const [t] = useTranslation('main');

  const { count, hasSelected } = useMemo(() => {
    const item = Object.keys(selectedRowKeys).find(key => selectedRowKeys[key].length > 0) || undefined;
    const count = item ? selectedRowKeys[item].length : 0;
    return {
      hasSelected: count > 0,
      selectedCount: count
    };
  }, [selectedRowKeys]);

  const handleOnCancel = () => {
    const selectedRows = Object.keys(selectedRowKeys).reduce((acc, key) => {
      acc[key] = [];
      return acc;
    }, {});
    onCancel?.(selectedRows);
  }

  return hasSelected ? (
    <TabTableMultipleSelection
      actions={[
        ...actions,
        {onClick: handleOnCancel, label: t('cancel')}
      ]}
      count={count}
      onCancel={handleOnCancel}
    />
  ) : '';
};

export default MultipleSelectionBar;
